import React from 'react';
import { UiComponents } from '@simulanisindia/ui';
import { useSelector } from 'react-redux';
import { menuData } from '../menuData';
import { INVOICE_TAB, VALIDITY_TAB } from '../../../Constant/constant';

const { SimListDropDown } = UiComponents;

const SelectType = ({ activeTab, setActiveTab, setButtonLabel }) => {
    const { checkedResource, dateRange, checkedApplication } = useSelector(state => state.subscriptionSlice);

    const handleTabChange = (newTab) => {
        setActiveTab(newTab);
        const buttonLabels = {
            [VALIDITY_TAB]: 'Plan Details',
            [INVOICE_TAB]: 'Submit',
            'expiry-alerts': 'Submit',
        };
        setButtonLabel(buttonLabels[newTab] || 'Validity');
    };

    return (
        <>
            <div className="sidebar">
                <SimListDropDown
                    menuData={menuData}
                    setActiveTab={handleTabChange}
                    activeTab={activeTab}
                />
            </div>
        </>
    )
}

export default SelectType